<template>
  <div class="h-full">
    <TopBar :show-toggle="true" />
    <SplashView />

    <div class="flex w-full flex-grow flex-col items-center">
      <img v-if="logo" class="mb-16 h-[73px] w-[172px]" :src="logo" />
      <div v-else class="skeleton mb-16 h-[73px] w-[172px] rounded"></div>

      <div class="flex w-full flex-col gap-5">
        <ActionCard
          class="bg-quaternary px-12 py-16 text-dark"
          :icon="IconQrcode"
          text="Ler QR Code da OP"
          :callback="goToMo"
        />
      </div>

      <div class="mb-0 mt-auto">
        <p class="text-center font-medium leading-[26px] text-muted-gray">
          OPERATION: {{ operationName }}
        </p>
        <p class="text-center font-medium leading-[26px] text-muted-gray">
          ACTIVITY: {{ activityName }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import logo from '@/assets/ssn-logo.png'
import ActionCard from '@/components/ActionCard/ActionCard.vue'
import TopBar from '@/components/TopBar/TopBar.vue'
import { useEventBus } from '@/plugins/eventBus/eventBus'
import { useAppStore } from '@/stores/app.store'
import { useUserStore } from '@/stores/user.store'
import { IconQrcode } from '@tabler/icons-vue'
import { computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import SplashView from '../SplashView.vue'

const eventBus = useEventBus()

const router = useRouter()

const appStore = useAppStore()
const userStore = useUserStore()

const activityName = computed(() => userStore.decodedToken?.activity.name.toUpperCase())
const operationName = computed(() =>
  userStore.decodedToken?.productionSequenceOperation.operation.name.toUpperCase()
)

async function goToMo() {
  router.push({ name: 'manufacturing-order' })
}

onMounted(() => {
  eventBus.on('home:scanOp', () => {
    goToMo()
  })

  appStore.actions.setCurrentPage('read_product')
  appStore.actions.setManufacturingOrder(null)
})

onUnmounted(() => {
  eventBus.off('home:scanOp')
})
</script>
